/**
 * Runtime JS counterpart to mods.ts for environments without TS loaders.
 */
/** Ordered list of all available mods. */
export const ALL_MODS = [
  'easy',
  'hardRock',
  'doubleTime',
  'halfTime',
  'hidden',
  'flashlight',
  'noFail',
];

/** Active mods applied to gameplay. */
export const mods = {};

export function isModActive(mod) {
  return !!mods[mod];
}

export function speedMultiplier() {
  if (isModActive('doubleTime')) return 1.5;
  if (isModActive('halfTime')) return 0.75;
  return 1;
}

export function applyAR(ar) {
  let ms = ar < 5 ? 1800 - 120 * ar : 1200 - 150 * (ar - 5);
  if (isModActive('easy')) ms *= 1.4;
  if (isModActive('hardRock')) ms /= 1.4;
  const res = ms > 1200 ? (1800 - ms) / 120 : (1200 - ms) / 150 + 5;
  return Math.min(10, Math.max(0, res));
}

export function applyOD(od) {
  let window = 64 - 3 * od;
  if (isModActive('easy')) window *= 1.4;
  if (isModActive('hardRock')) window /= 1.4;
  const res = (64 - window) / 3;
  return Math.min(10, Math.max(0, res));
}

export function applyCS(cs) {
  return Math.min(10, Math.max(0, cs));
}

